import { Card, CardFulfillment, CardStatus } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
export function getCardStatusPill(card) {
  const cardStatus = card.status;
  switch (cardStatus) {
    case CardStatus.CARD_STATUS_TERMINATED:
      return {
        trackingText: 'deactivated',
        translationKey: 'banking.checking.cardSettings.page.status.terminated',
        variant: 'critical'
      };
    case CardStatus.CARD_STATUS_LOCKED:
      return {
        trackingText: 'locked',
        translationKey: 'banking.checking.cardSettings.page.status.locked',
        variant: 'warning'
      };
    case CardStatus.CARD_STATUS_SUSPENDED:
      return {
        translationKey: 'banking.checking.cardSettings.page.status.suspended',
        variant: 'critical',
        trackingText: 'blocked'
      };
    case CardStatus.CARD_STATUS_ACTIVE:
      return getCardExpirationStatusPill(card);
    case CardStatus.CARD_STATUS_ISSUED:
    case CardStatus.CARD_STATUS_ACTIVATABLE:
    case CardStatus.CARD_STATUS_ORDERED:
      return getCardExpirationStatusPill(card) ?? getCardFulfillmentStatusPill(card);
    default:
      return null;
  }
}
function getCardExpirationStatusPill(card) {
  const expirationStatus = card.expirationData?.status;
  switch (expirationStatus) {
    case Card.Expiration.ExpirationStatus.EXPIRATION_STATUS_EXPIRING:
      return {
        trackingText: 'expiring',
        translationKey: 'banking.checking.cardSettings.page.status.expiring',
        variant: 'critical'
      };
    case Card.Expiration.ExpirationStatus.EXPIRATION_STATUS_EXPIRED:
      return {
        trackingText: 'expired',
        translationKey: 'banking.checking.cardSettings.page.status.expired',
        variant: 'critical'
      };
    default:
      return null;
  }
}
function getCardFulfillmentStatusPill(card) {
  const fulfillmentStatus = card.fulfillment?.status;
  switch (fulfillmentStatus) {
    case CardFulfillment.FulfillmentStatus.FULFILLMENT_STATUS_DELIVERED:
      return {
        trackingText: 'delivered',
        translationKey: 'banking.checking.cardSettings.page.status.delivered',
        variant: 'success'
      };
    case CardFulfillment.FulfillmentStatus.FULFILLMENT_STATUS_PROCESSING:
      return {
        trackingText: 'processing',
        translationKey: 'banking.checking.cardSettings.page.status.processing',
        variant: 'normal'
      };
    case CardFulfillment.FulfillmentStatus.FULFILLMENT_STATUS_SHIPPED:
      return {
        trackingText: 'shipped',
        translationKey: 'banking.checking.cardSettings.page.status.shipped',
        variant: 'emphasis'
      };
    default:
      return null;
  }
}